import { axiosi } from "../../config/axios";

export const fetchPaymentsByUserId = async (userId) => {
  try {
    const res = await axiosi.get(`/payments/user/${userId}`);
    return res.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const createPayment = async (paymentData) => {
  try {
    const res = await axiosi.post("/payments", paymentData);
    return res.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const updatePaymentById = async (update) => {
  try {
    const res = await axiosi.patch(`/payments/${update._id}`, update);
    return res.data;
  } catch (error) {
    throw error.response.data;
  }
};
